import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Aso from '@pages/score/aso';
import Cro from '@pages/score/cro';
import Mko from '@pages/score/mko';
import Rso from '@pages/score/rso';

const AsoRoutes = () => {
  return (
    <>
      <Routes>
        <Route path="/status" element={<Aso />} />
        <Route path="/mko" element={<Mko />} />
        <Route path="/cro" element={<Cro />} />
        <Route path="/rso" element={<Rso />} />
      </Routes>
    </>
  );
};

export default AsoRoutes;
